import { Images } from '../../../../@resources/img';
import { Sticky } from '../../paper/Sticky';
import { TabularImportMappingStep } from '../steps/TabularImportMappingStep';
import { MappingFilter, MappingTarget, TabularImportStrategy } from '../TabularImportModel';
import { createMappingOnlyTabularImportStrategyFunction } from './Shared';

export const StickiesTabularImportStrategy: TabularImportStrategy = {
    id: 'stickies',
    label: 'Import as Stickies',
    image: Images.ImportStickies,
    steps: [
        TabularImportMappingStep({
            type: Sticky,
            typeLabel: 'Stickies',
            preview: [2, 4],
            targets: [
                MappingTarget('Content', 'content', MappingFilter.text(140)),
                MappingTarget('Color', 'background', MappingFilter.color),
            ]
        }),
    ],
    apply: createMappingOnlyTabularImportStrategyFunction(Sticky),
};
